














import Video from '@/components/common/Video.vue';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component({
  components: {
    Video
  }
})
export default class extends Vue {
  // 接收参数
  @Prop() public data!: object[];
  @Prop() public isActive!: boolean;

  @Watch('isActive')
  activeChange(val) {
    if (!val) {
      if (this.$refs.customVideo) {
        (this.$refs.customVideo as any).suspendVideo();
      }
    }
  }
}
